export default function getRandomArrayItem<T = unknown>(array: T[]): T | null {
    if (!array?.length) {
        return null;
    }

    const randomIndex = Math.round(Math.random() * (array.length - 1));

    return array[randomIndex];
}
